<div *ngIf="message" [class]="level + ' base'" [innerHtml]="message"></div>
